<template>
  <a-carousel autoplay>
    <div
      v-for="(item, index) in reportData"
      :key="index"
      @click="jumpUrl(item)"
      v-show="item.isRunning"
    >
      <h3>
        <span
          :style="{
            backgroundImage: 'url(' + item.banner_img_url + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
          }"
        ></span>
      </h3>
    </div>
  </a-carousel>
</template>
<script>
export default {
  data() {
    return {
      reportData: [],
    };
  },
  activated() {
    // 显示年度报告的入口
    if (
      localStorage.getItem("date") != null &&
      localStorage._user_data_sso_token &&
      localStorage._user_data_id &&
      localStorage._username
    ) {
      this.show_entrance();
    }
  },
  methods: {
    show_entrance() {
      let _this = this;
      let static_URL = "";
      if (location.origin.indexOf(".eceibs.net") != -1) {
        static_URL = `${location.protocol}//weixin.report.eceibs.net`; //生产
      } else if (location.origin.indexOf(".test.eceibs.com.cn") != -1) {
        static_URL = `${location.protocol}//weixin.report.test.eceibs.com.cn`; //测试
      } else if (location.origin.indexOf(".test2.eceibs.com.cn") != -1) {
        static_URL = `${location.protocol}//weixin.report.test2.eceibs.com.cn`; //测试2
      } else {
        static_URL = `${location.protocol}//weixin.report.el.net`; //开发
      }
      let url = `${static_URL}/index.php/mobile/active-report/check-status`;
      //   let url = `https://weixin.report.test.eceibs.com.cn/index.php/mobile/active-report/check-status`
      var data = {
        company: localStorage.getItem("_user_data_company_id"),
        user_id: localStorage.getItem("_user_data_id"),
        platform: "v3",
      };
      $.ajax({
        url: url,
        dataType: "json",
        type: "POST",
        data: data,
        async: true,
        success: function (res) {
          if (res.code == 0) {
            _this.reportData = res.result;
          } else {
            _this.$message.destroy();
          }
        },
      });
    },
    jumpUrl(item) {
      let url = `${item.jump_url}?company=${localStorage.getItem(
        "_user_data_company_id"
      )}&user_id=${localStorage.getItem("_user_data_id")}&uuid=${
        item.uuid
      }&platform=v3&active_type=${item.active_type}&isfrom=5`;
      window.location.href = url;
    },
  },
};
</script>

<style lang="less" scoped>
.ant-carousel {
  .slick-slide h3 {
    height: 1.85rem;
    background: #fff;
    text-align: center;
    span {
      display: inline-block;
      margin: 0.3rem;
      width: 6.9rem;
      height: 1.25rem;
    }
  }
  /deep/ .slick-dots {
    bottom: 0.5rem;
    button {
      width: 0.1rem;
      height: 0.1rem;
      border-radius: 50%;
    }
    .slick-active button {
      width: 0.13rem;
      height: 0.13rem;
      border-radius: 50%;
    }
  }
}
</style>
